/**
 * Listens to window scroll event in an optimized way.
 */
function observeWindowScroll(callback: () => void, preferPassive = false) {
  let timeout: number | undefined;

  const onFrame = () => callback();

  function onScroll() {
    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }

    // don't fire the callback more often than once per each rendered frame
    timeout = window.requestAnimationFrame(onFrame);
  }

  window.addEventListener('scroll', onScroll, { passive: preferPassive });

  function stopObserving() {
    window.removeEventListener('scroll', onScroll);
  }

  return { stopObserving };
}

export { observeWindowScroll };
